import React from 'react'
import LinesEllipsis from 'react-lines-ellipsis'

import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'

const useStyles = makeStyles(style)
 
export default function Standards ({context}) {

  const classes = useStyles()
  
  const {translate, standardsContext, questionId} = context

  const { assessmentIndicators = {}, assessmentStandards = {}} = standardsContext

  const hasIndicators = Object.keys(assessmentIndicators).length > 0;

  const expectations = assessmentStandards?.items[0]?.expectations || {}

  return (
        <Box className={classes.indicator}>
            { questionId && hasIndicators && !!assessmentIndicators[questionId]
                    ? (
                        <>
                        <Box className={classes.indicatorTitle}>{translate('indicator-header')}:</Box>
                        <Box className={classes.indicatorText}>{assessmentIndicators[questionId][0].code}</Box>
                        </>
                    )
                    : undefined}
            
            { questionId && !hasIndicators && expectations.length > 0
                    ? (
                        <>
                        <Box className={classes.indicatorTitle}>{translate('expectations')}:</Box>
                        <Box className={classes.expectationText}>
                            { 
                            expectations.map((exp) => exp.references.find(ref => ref.id == questionId) 
                                ? (
                                    <LinesEllipsis
                                    text={exp.description}
                                    maxLine={2}
                                    ellipsis="..."
                                    trimRight
                                    basedOn='letters'
                                    />)
                                : undefined)
                            }
                        </Box>
                        </>
                    )
                    : undefined
                }
        </Box>
  )  
}


function style(theme) {
  return {
      indicator: {
        display: 'flex'
      },
      indicatorTitle: {
        fontWeight: 'bold',
        marginRight: 3
      },
      indicatorText: {
        textTransform: 'uppercase'
      },
      expectationText: {
        textTransform: 'initial'
      }
  }
}
